import { useQuery } from '@tanstack/react-query';

import type { GlobalDashboardRegistry } from '@features/insights/registries/dashboard-registries/types';

type Data = {
  registry: GlobalDashboardRegistry;
};

export const useGlobalDashboardRegistry = (
  hasDataExplorer: boolean | null,
  dataExplorerIsLoading: boolean,
) => {
  return useQuery<Data>({
    queryFn: () => {
      if (hasDataExplorer) {
        return import(
          '@features/insights/registries/dashboard-registries/ch-dashboard-registry/ch-dashboard-registry'
        );
      }
      return import(
        '@features/insights/registries/dashboard-registries/es-dashboard-registry/es-dashboard-registry'
      );
    },
    enabled: !dataExplorerIsLoading,
    gcTime: 0,
    meta: {
      persist: false,
    },
    queryKey: [hasDataExplorer],
  });
};
